import type { NetworkCallbacks } from '@atlassian/search-client';

import {
	onTaskFail,
	onTaskStart,
	onTaskSuccess,
	type TASK_NAMES,
} from './events/vital-stats-events';

type TaskNameValue = (typeof TASK_NAMES)[keyof typeof TASK_NAMES];

/**
 * Creates network callbacks for tracking network requests with VitalStats analytics.
 */
export const createVitalStatsNetworkCallbacks = (
	taskId: string,
	taskName: TaskNameValue,
	searchSessionId: string,
	fireAnalyticsEvent: (event: any) => void,
): NetworkCallbacks => {
	const baseParams = { taskId, task: taskName, searchSessionId };

	return {
		onStart: () => fireAnalyticsEvent(onTaskStart(baseParams)),
		onSuccess: () => fireAnalyticsEvent(onTaskSuccess(baseParams)),
		onError: (errorName: string, errorMessage: string) =>
			fireAnalyticsEvent(onTaskFail({ ...baseParams, moreContext: { errorName, errorMessage } })),
	};
};
